import {
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel
} from '@ionic/react'
import { createOutline } from 'ionicons/icons'
import moment from 'moment'
import React from 'react'

interface Props {
  onEdit?: () => any
  person: any
}

export const PersonCard: React.FC<Props> = (props) => {
  return (
    <IonCard>
      <IonCardHeader>
        {props.onEdit && (
          <IonButton
            style={{
              position: 'absolute',
              zIndex: 10,
              right: 10,
              top: 10,
            }}
            onClick={props.onEdit}
            fill={'clear'}
          >
            <IonIcon slot="icon-only" icon={createOutline} />
          </IonButton>
        )}
        <IonCardTitle>Personen Daten</IonCardTitle>
      </IonCardHeader>

      {props.person.title && (
        <IonItem>
          <IonLabel position="floating">Titel</IonLabel>
          <IonInput value={props.person.title} readonly />
        </IonItem>
      )}

      <IonItem>
        <IonLabel position="floating">Vorname</IonLabel>
        <IonInput value={props.person.firstName} readonly />
      </IonItem>

      <IonItem>
        <IonLabel position="floating">Nachname</IonLabel>
        <IonInput value={props.person.lastName} readonly />
      </IonItem>

      <IonItem>
        <IonLabel position="floating">Geschlecht</IonLabel>
        <IonInput value={props.person.gender === 'f' ? 'Frau' : 'Mann'} readonly />
      </IonItem>

      <IonItem>
        <IonLabel position="floating">Geburtstag</IonLabel>
        <IonInput value={moment(props.person.birthday).format('YYYY-MM-DD')} readonly />
      </IonItem>
    </IonCard>
  )
}
